<template>
  <div>
    <CGQ v-if="type === 'cgq'" />
    <FM v-else />
    <div class="rtu" v-if="type === 'rtu'">
      <div class="title">所属RTU信息</div>
      <div class="col" v-show="rtu.name">RTU名称：{{ rtu.name }}</div>
      <div class="col" v-show="rtu.no">编号：{{ rtu.no }}</div>
      <div class="col" v-show="typeof rtu.signal === 'number'">
        信号强度：{{ rtu.signal }} dbm
      </div>
      <div class="col" v-show="typeof rtu.voltage === 'number'">
        电压：{{ rtu.voltage }} v
      </div>

      <div class="col">阀门压力值{{ sensorVal }} Kpa</div>
      <div class="col">端口号：{{ info.port }}</div>
      <!-- <van-loading class="loading" type="spinner" color="#1989fa" /> -->
      <div class="title">操作记录</div>
      <div class="row">阀门开关操作总数：{{ allCount }}</div>
      <div class="row">
        阀门开关操作失败次数：
        <span class="text-line" @click="handleClick">{{ failCount }}</span>
      </div>

      <div class="btn">
        <van-button class="orangeToYellow threbtn" @click.stop="getRTUPressure">
          手动采集阀门压力值
        </van-button>
      </div>
    </div>
  </div>
</template>

<script>
import FM from './fm'
import CGQ from './cgq'
import { mapState } from 'vuex'

export default {
  components: {
    FM,
    CGQ,
  },
  data () {
    return {
      type: '',
      info: {},
      rtu: {},
      timer: null,
      index: 0,
      allCount: 0,
      failCount: 0,
      sensorVal: null,
    }
  },
  computed: {
    ...mapState(['subscribeTag', 'sseData']),
  },

  watch: {
    subscribeTag (v) {
      // 有改变 则修改收到的值
      this.getRTUInfo(this.info.rtuNo)
    },
  },

  async created () {
    const type = this.$route.query.type
    this.type = type
    this.info = JSON.parse(sessionStorage.getItem('liveSettingData'))
    await this.getRTUInfo()

    type === 'rtu' && this.getRTUPressure()

    // if (type !== "cgq") {
    //   // 定时30秒刷RTU信息
    //   this.timer = setInterval(() => {
    //     if (this.index > 30) {
    //       return clearInterval(this.timer);
    //     }
    //     this.getRTUInfo();
    //   }, 2 * 1000);
    // }

    const sucNum = await this.getSwitchActionStatitic(this.info.id, 1)
    const failNum = await this.getSwitchActionStatitic(this.info.id, 2)

    this.allCount = sucNum + failNum
    this.failCount = failNum
  },

  destroyed () {
    clearInterval(this.timer)
  },

  methods: {
    async getRTUInfo () {
      await this.$api
        .getRtuList({
          gatewayNo: localStorage.getItem('no'),
        })
        .then((res) => {
          if (res.data) {
            const i = res.data.findIndex((o) => o.no === this.info.rtuNo)
            if (i != null) {
              this.rtu = { ...res.data[i] }
              this.index++
            }
          }
        })
    },

    // 查水势压力值
    async getRTUPressure () {
      await this.$toast.loading({
        message: this.$t('common.loading'),
        forbidClick: true,
        duration: 0,
      })

      try {
        await this.$api
          .getRtuPressure({
            rtuNo: this.info.rtuNo || this.info.no,
          })
          .then((res) => {
            if (res.errcode === 0) {
              const { sensorVal } = res.retList[0]
              this.sensorVal = sensorVal
            }
          })
          .finally(() => {
            this.$toast.clear()
          })
      } catch (e) {
        console.error(e)
      }
    },

    // 开关统计次数
    async getSwitchActionStatitic (id, status) {
      return await this.$api
        .getSwitchActionNum({
          eqValveId: id,
          status, // “1-成功;2-失败”
        })
        .then((res) => {
          return res.count
        })
    },

    handleClick () {
      this.$router.push({
        path: '/fmError',
        query: {
          id: this.info.id,
        },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.rtu {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  width: 6.7rem;
  margin: 0 auto;
  padding-top: 0.8rem;
  font-size: 16px;

  .title {
    width: 100%;
    font-weight: 500;
    margin-bottom: 0.1rem;
    margin-top: 0.3rem;
  }

  .row {
    display: block;
    width: 100%;
  }

  .col {
    width: 50%;
    line-height: 26px;
  }

  .text-line {
    color: blue;
    text-decoration: underline;
  }
}

.btn {
  width: 100%;
  margin-top: 20px;

  button {
    border-radius: 0.1rem;
    width: 100%;
    height: 56px;
    color: #ffffff;
    font-size: 16px;
  }
}
</style>
